<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphImageText

    div
      .ParagraphImageText_image(v-if="item.derivatives")
        AdaptativeImg(:derivatives="item.derivatives" :type="'block'" :fit="false" :name="item.alt")
      p.ParagraphImageText_description {{ item.description }}

</template>

<script>

import AdaptativeImg from '@/components/common/AdaptativeImg'

export default {
  components: {
    AdaptativeImg
  },
  props: ['item'],
  data () {
    return {}
  }
}
</script>

<style lang="stylus" scoped>

.ParagraphImageText
  box-sizing border-box
  padding 0 20px
  max-width: 910px

  div
    position relative
    display block
    width 100%

    .ParagraphImageText_image
      position relative
      display block
      width 100%
      margin 0 auto
      max-width 750px

  p
    width 100%
    text-align center
    font-weight 600
    font-size 20px
    line-height 40px
    padding-top 40px

</style>
